'use strict';

require('./thirdParty/bootstrap-datepicker');
